import { createPinia } from "pinia";

import { useProjectsStore } from "@/store/modules/projects";
import { useDocumentsStore } from "@/store/modules/documents";
import { useContributorsStore } from "@/store/modules/contributors";
import { useRolesStore } from "@/store/modules/roles";
import { useAgenciesStore } from "@/store/modules/agencies";
import { useReportsStore } from "@/store/modules/reports";
import { useInstallationsStore } from "@/store/modules/installations";
import { useConfigurationLinesStore } from "@/store/modules/configurationLines";
import { useSamplesStore } from "@/store/modules/samples";
import { useSampleFlasksStore } from "@/store/modules/sampleFlasks";
import { useSumStore } from "@/store/modules/sum";
import { usePhasesStore } from "@/store/modules/phases";
import { useVlesStore } from "@/store/modules/vles";
import { useFlowsStore } from "@/store/modules/flows";
import { useRecordBooksStore } from "@/store/modules/recordBooks";
import { useOrderFormsStore } from "@/store/modules/orderForms";
import { useAcquisitionRecordBooksStore } from "@/store/modules/acquisitionRecordBooks";
import { useAnalysisResultStore } from "@/store/modules/analysisResult";
import { useSampleFlaskPrepsStore } from "@/store/modules/sampleFlaskPrep";
import { useConstatsStore } from "@/store/modules/constats";

export const pinia = createPinia();

const RESETTABLE_STORES = [
  useProjectsStore,
  useDocumentsStore,
  useContributorsStore,
  useRolesStore,
  useAgenciesStore,
  useReportsStore,
  useInstallationsStore,
  useConfigurationLinesStore,
  useSamplesStore,
  useSampleFlasksStore,
  useSumStore,
  usePhasesStore,
  useVlesStore,
  useFlowsStore,
  useRecordBooksStore,
  useOrderFormsStore,
  useAcquisitionRecordBooksStore,
  useAnalysisResultStore,
  useSampleFlaskPrepsStore,
  useConstatsStore,
];
const PRESERVED_ON_RESET = {
  projects: ["projectList", "totalProjects", "favorites"],
  constats: ["detectionsInFlight"],
};

export const resetStores = () => {
  RESETTABLE_STORES.forEach((useStore) => {
    if (!(useStore.$id in pinia.state.value)) return;
    const store = useStore();
    const preservedKeys = PRESERVED_ON_RESET[useStore.$id];
    const preserved = preservedKeys?.map((key) => [key, store[key]]);
    store.$reset();
    if (preserved) store.$patch(Object.fromEntries(preserved));
  });
};

export default pinia;
